import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    fuel-icon {
      padding-right: ${theme.spacing.km1};
    }

    fuel-button::part(button) {
      display: flex;
      background: transparent;
      text-decoration: underline;
      text-underline-offset: 2px;
      padding: 0;
      border: 0;
      min-width: auto;
      height: auto;
    }
  `}
`;
